import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosHandler from "./axiosHandler";

export const getAllDepartment = createAsyncThunk(
    "department/getAllDepartment",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axiosHandler.get(`/department/getAllDepartment`);
        return response?.data?.data;
      } catch (error) {
        return throwError(error,rejectWithValue)
      }
    }
  );
  
  export const createDepartment = createAsyncThunk(
    "department/create",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosHandler.post("/department/create", data);
        return response?.data?.data;
      } catch (error) {
        return throwError(error,rejectWithValue)
      }
    }
  );
  
  export const deleteDepartment = createAsyncThunk(
    "department/delete",
    async (id, { rejectWithValue }) => {
      try {
       await axiosHandler.delete(
          `/department/deleteDepartment/${id}`
        );
        return id;
      } catch (error) {
        return throwError(error,rejectWithValue)
      }
    }
  );
  
  export const updateDepartment = createAsyncThunk(
    "department/update",
    async ({ id, data }, { rejectWithValue }) => {
      try {
        const response = await axiosHandler.post(
          `/department/updateDepartment/${id}`,
          data
        );
        return response.data?.data;
      } catch (error) {
        return throwError(error,rejectWithValue)
      }
    }
  );


  export const uploadBunchDepartment = createAsyncThunk(
    "admin/upload-department-excel",
    async (  data , { rejectWithValue }) => {
      try {
        const response = await axiosHandler.post(`/admin/upload-department-excel`, data);
  
        return response?.data;
      } catch (error) {
        return throwError(error, rejectWithValue);
      }
    }
  );
  
  const throwError=(error,rejectWithValue)=>{
    return rejectWithValue(
         error?.response?.data|| "An error occurred"
      );
  }